// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/Opengraph/InlineOpengraphResult.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/Opengraph/InlineOpengraphResult.tsx");
  import.meta.hot.lastModified = "1717182690460.063";
}
// REMIX HMR END

import clsx from "clsx";
import IconResolver from "~/components/IconResolver";
export default function InlineOpengraphResult({
  facebook,
  google,
  linkedin,
  slack,
  twitter
}) {
  const items = [{
    token: "google",
    value: google
  }, {
    token: "twitter",
    value: twitter
  }, {
    token: "linkedin",
    value: linkedin
  }, {
    token: "facebook",
    value: facebook
  }, {
    token: "slack",
    value: slack
  }];
  return <div className="flex gap-8 w-full mb-4">
      {items.map(({
      token,
      value
    }) => {
      return <p className={clsx("flex flex-col gap-1 items-center text-xs", value ? "text-secondary-600" : "text-neutral-600")}>
            <IconResolver className="w-5 h-5" token={token} />
            <span>{value ? "Working" : "Not Working"}</span>
          </p>;
    })}
    </div>;
}
_c = InlineOpengraphResult;
var _c;
$RefreshReg$(_c, "InlineOpengraphResult");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;